import * as React from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { SecurityRole, SecurityGuard, OptionTableCell, TableButton } from "@duosoftbg/nacid-components";
import PortalSearchTable from "../../../common/table/PortalSearchTable";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { openModal } from "../../../../../store/redux/slice/ComponentsControl/emailNotificationsControl";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";

const headCells = [
  {
    id: "number",
    label: "l.table.head.number",
    sortable: false,
  },
  {
    id: "createdDate",
    label: "l.table.head.createdDate",
  },
  {
    id: "sentDate",
    label: "l.table.head.sentDate",
  },
  {
    id: "subject",
    label: "l.table.head.subject",
  },
  {
    id: "recipients",
    label: "l.table.head.recipients",
  },
  {
    id: "status",
    label: "l.table.head.status",
    sortable: false,
  },
  {
    id: "options",
    label: "",
    sortable: false,
  },
];

const EmailNotificationsListTable = ({ total, records, blockTable, onPageOrOrderChange, group }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { getValues } = useFormContext();

  const handleOpenModal = (id, modalType) => {
    const payload = { id, modalType };
    dispatch(openModal(payload));
  };

  return (
    <PortalSearchTable
      group={group}
      headCells={headCells}
      total={total}
      blockTable={blockTable}
      onPageOrOrderChange={onPageOrOrderChange}
    >
      <TableBody>
        {records.map((row, index) => {
          return (
            <TableRow hover key={row.id}>
              <TableCell>{index + 1 + getValues().page * getValues().pageSize}</TableCell>
              <TableCell>{row.createdDate}</TableCell>
              <TableCell>{row.sentDate}</TableCell>
              <TableCell>{row.subject}</TableCell>
              <TableCell>{row.recipients}</TableCell>
              {null == row.sentDate &&
                false === row.skipSending &&
                !(null != row.comment && row.comment.includes("resent")) && (
                  <TableCell>{t("l.email.notification.inSendingProcess")}</TableCell>
                )}
              {null != row.sentDate && !(null != row.comment && row.comment.includes("resent")) && (
                <TableCell>{t("l.email.notification.sent")}</TableCell>
              )}
              {null == row.sentDate && true === row.skipSending && (
                <TableCell>{t("l.email.notification.notSent")}</TableCell>
              )}
              {null != row.comment && row.comment.includes("resent") && (
                <TableCell>{t("l.email.notification.resent")}</TableCell>
              )}
              <OptionTableCell>
                <TableButton type={"view"} onClick={() => handleOpenModal(row.id, "view")} />
                <SecurityGuard checkForRoles={[SecurityRole.AcEmailNotificationsDelete]}>
                  <TableButton type={"remove"} onClick={() => handleOpenModal(row.id, "delete")} />
                </SecurityGuard>
                <SecurityGuard checkForRoles={[SecurityRole.AcEmailNotificationsResend]}>
                  <TableButton type={"resend"} onClick={() => handleOpenModal(row.id, "resend")} />
                </SecurityGuard>
              </OptionTableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </PortalSearchTable>
  );
};

export default EmailNotificationsListTable;
